var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-only"},[_c('trigger-button',{attrs:{"show-mode":_vm.showMode}}),_vm._v(" "),_c('search-screen')],1)}
var staticRenderFns = []

export { render, staticRenderFns }